/**
 * Renders the Markdown-style **bold** and *italic* markers that the content JSON
 * carries inside plain-text fields, as real React elements.
 *
 * The grammar pillars alone hold 2,871 `**…**` spans across A2–C1 — they are how
 * the authors highlight the word the rule is about ("Was **würdest du** an meiner
 * Stelle **tun**?"). Rendered as plain text they show up as literal asterisks,
 * which is what shipped on the first pass of the public grammar pages.
 *
 * Several renderers under src/components/lessons/ solve this with
 * dangerouslySetInnerHTML. That is fine for hand-checked lesson content, but
 * these pages are public, prerendered, and built by mapping over data files, so
 * this returns nodes instead — no HTML is ever parsed, and a stray angle bracket
 * in the source can never become markup.
 *
 * Unmatched markers are left alone rather than swallowed: if the source says
 * "3 ** 4" it stays "3 ** 4".
 */
import React from 'react';

const TOKEN = /(\*\*[^*]+\*\*|\*[^*\n]+\*)/g;

export function renderEmphasis(text) {
  if (typeof text !== 'string' || !text) return text;
  if (!text.includes('*')) return text;

  const parts = text.split(TOKEN).filter((p) => p !== '');

  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return (
        <strong key={i} className="font-bold text-black">
          {part.slice(2, -2)}
        </strong>
      );
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return part;
  });
}

export default renderEmphasis;
